export const education = {
    university: "FIAP — São Paulo, SP",
    degree: "Bacharelado em Sistemas de Informação",
    period: "Jan 2022 - Dez 2025",
    description: "Algoritmos, POO (Java), Desenvolvimento Mobile (Flutter/Kotlin/Swift), Microsserviços, PL/SQL, Análise de Dados, Engenharia de Software e Gestão Empresarial.",
    highlights: [
      "Finalista do Challenge anual com projeto de Robô de Batalha",
      "Conhecimentos aprofundados em Java e Programação Orientada a Objetos",
      "Desenvolvimento mobile com Kotlin, Flutter e Swift",
      "Desenvolvimento web com JavaScript, HTML, CSS e Bootstrap",
      "Banco de dados, PL/SQL e modelagem de dados",
      "Estrutura de redes e arquitetura de sistemas",
      "Algoritmos e estrutura de dados",
      "Gestão de negócios e técnicas empresariais",
      "Business Intelligence com Excel e Power BI",
      "Cyber segurança e governança de TI",
      "Arquitetura de microsserviços",
      "Engenharia de software e metodologias ágeis",
      "Conceitos de Inteligência Artificial e aplicação de modelos LLM",
      "Cloud Computing e serviços AWS, GCP e Azure"
    ]
  };
